/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Legal_PrivacyInputs */

const en_auth_legal_privacy = /** @type {(inputs: Auth_Legal_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

const pl_auth_legal_privacy = /** @type {(inputs: Auth_Legal_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polityka prywatności`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Auth_Legal_PrivacyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_legal_privacy = /** @type {((inputs?: Auth_Legal_PrivacyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Legal_PrivacyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_legal_privacy(inputs)
	return en_auth_legal_privacy(inputs)
});